import { Router, ActivatedRoute } from '@angular/router';
import { CUSTOMER_COMP } from './../../customer/customer.const';
import { API_CALL_ERROR } from './../../../store/action';
import { ApiService } from './../../../api/api.service';
import { AppInjector } from './../../../app-injector';
import {takeEvery, put, select} from 'redux-saga/effects';
import {
  FETCH_PAYMENTS_REQUESTED,
  FETCH_PAYMENTS_SUCCEEDED,
  SORT_PAYMENTS_REQUESTED,
  SORT_PAYMENTS_SUCCEEDED,
  UPDATE_PAYMENT_FILTER
} from './list.actions';
import * as _ from 'lodash';
import {UtilityService} from "../../../common/services/utility/utility.service";
import {GET_ALL_DESIGNERS_SUCCEEDED} from "../../designer/designer.actions";

function* fetchPayments(action) {
  const api = AppInjector.get(ApiService);
  try {
    let results = yield api.payment.get(action.data.pagination, action.data.sorts, action.data.filters).toPromise();
    AppInjector.get(UtilityService).reset();
    yield put({ type: FETCH_PAYMENTS_SUCCEEDED, data: results.items, pagination: results.pagination, defaultSelection: action.data.defaultSelection });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchFetchPaymentsRequest() {
  yield takeEvery(FETCH_PAYMENTS_REQUESTED, fetchPayments);
}

function* sortPayments(action) {
  const api = AppInjector.get(ApiService);
  try {
    let results = yield api.payment.sort(action.data).toPromise();
    yield put({ type: SORT_PAYMENTS_SUCCEEDED, data: results.items, total: results.total });
  } catch (e) {
    yield put({ type: API_CALL_ERROR, error: e });
  }
}

function* watchSortPaymentsRequest() {
  yield takeEvery(SORT_PAYMENTS_REQUESTED, sortPayments);
}

function* filterPayment(action) {
  try {
    const activatedRoute = AppInjector.get(ActivatedRoute);
    const router = AppInjector.get(Router);
    const url = activatedRoute.snapshot.url;
    let queryParams = _.assign({}, activatedRoute.snapshot.queryParams, { page: 1 });
    let constraints = {};
    queryParams = _.assign(queryParams, { constraints: JSON.stringify(constraints) });
    router.navigate([url], { queryParams: queryParams });
  } catch (e) {}
}

function* watchPaymentFilterRequest() {
  yield takeEvery(UPDATE_PAYMENT_FILTER, filterPayment);
}

export default [watchPaymentFilterRequest, watchFetchPaymentsRequest, watchSortPaymentsRequest];
